import type { DraftEvaluation, StepPreview } from "../types";

// Contract kinds a staff preview can mint. Mirrors backend send.PREVIEW_CONTRACT_KINDS,
// the source of truth; change both together. A Document step (`step.document`) is
// previewable whatever its kind.
const PREVIEW_KINDS: ReadonlySet<string> = new Set([
  "main_contract",
  "addendum",
  "one_off_contract",
]);

function isMainContractStep(step: StepPreview): boolean {
  if (step.skipped || step.type !== "contract") return false;
  // The server decides what is a Document; every Document is previewable.
  if (step.document) return true;
  // Prefer kind (standalone also uses key "contract"; refinance shares that key).
  if (step.kind != null) return PREVIEW_KINDS.has(step.kind);
  // Older defaults payloads omitted kind; onboarding's main step key is "main".
  return step.key === "main";
}

/**
 * True when the draft sends a document: staff fill it and it is emailed, the merchant
 * signs nothing. The rule is the backend's (`ContractDocument.is_document`, its
 * Document section), sent as `step.document`.
 */
export function isDocumentDraft(evaluation: DraftEvaluation | null | undefined): boolean {
  return Boolean(evaluation?.steps_preview.some((step) => !step.skipped && step.document));
}

/** True when the draft still includes an unskipped contract step staff can preview. */
export function hasMainContract(evaluation: DraftEvaluation | null | undefined): boolean {
  return Boolean(evaluation?.steps_preview.some(isMainContractStep));
}
